import { useState } from 'react';
import { SerializedError } from '@reduxjs/toolkit';
import { useForm, RegisterOptions } from 'react-hook-form';

import { useAppDispatch } from '../../app/hooks';
import { signUpAction, SignUpParams } from './authSlice';

const initialState: SignUpParams = {
  email: '',
};

const field_options: Partial<Record<keyof SignUpParams, RegisterOptions>> = {
  email: { 
    required: 'Email is required',
    pattern: {
      // eslint-disable-next-line
      value: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      message: 'Invalid email',
    },
  },
};

export function SignUp() {
  const dispatch = useAppDispatch();
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: initialState,
  });
  const [api_error, setApiError] = useState<SerializedError|undefined>();

  const onSignUp = async(data: typeof initialState) => {
    let signup_result = await dispatch(signUpAction(data));
    if (signUpAction.rejected.match(signup_result)) {
      setApiError(signup_result.error);
      const subscription = watch(() => {
        setApiError(undefined);
        subscription.unsubscribe();
      });
    } else {
      setApiError({
        name: 'Please click magic link for your email'
      });
    }
  };

  return (
    <div className="container-lg">
      <div className="row justify-content-md-center">
        <form className="col col-md-5 card border-dark mb-3 mt-5" onSubmit={handleSubmit(onSignUp)}>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                className="form-control"
                id="email"
                placeholder="email"
                { ...register('email', field_options.email) }
              />
              <span className="text-danger">{errors.email?.message}</span>
            </div>
            <span className="text-danger">{api_error?.message ?? api_error?.name}</span>
            <div className="d-grid gap-2 mt-5">
              <button type="submit" className="btn btn-outline-primary">SignUp</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
